module.exports = __webpack_public_path__ + "img/icon_go-to-album.5c0638c4.svg";